var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5C15.1046 10.5 16 9.60457 16 8.5C16 7.39543 15.1046 6.5 14 6.5C12.8954 6.5 12 7.39543 12 8.5C12 9.60457 12.8954 10.5 14 10.5Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15C15.5 15.2237 15.5361 15.4459 15.6068 15.6581L16.9487 19.6838C17.1233 20.2077 16.8402 20.774 16.3162 20.9487C15.7923 21.1233 15.226 20.8402 15.0513 20.3162L14.0949 17.4469C14.0645 17.3557 13.9355 17.3557 13.9051 17.4469L12.9487 20.3162C12.774 20.8402 12.2077 21.1233 11.6838 20.9487C11.1598 20.774 10.8767 20.2077 11.0513 19.6838L12.2434 16.1075C12.4134 15.5976 12.5 15.0637 12.5 14.5263V13.6484C11.0597 13.4519 9.7069 12.9763 8.49927 12.2778C8.02121 12.0012 7.85785 11.3895 8.13439 10.9114C8.41094 10.4334 9.02267 10.27 9.50073 10.5465C10.8235 11.3117 12.359 11.75 14 11.75C15.641 11.75 17.1765 11.3117 18.4993 10.5465C18.9773 10.27 19.5891 10.4334 19.8656 10.9114C20.1421 11.3895 19.9788 12.0012 19.5007 12.2778C18.2931 12.9763 16.9403 13.4519 15.5 13.6484V15Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14ZM24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityOutline);
export default __webpack_public_path__ + "static/media/accessibility_outline.79ece5375d535c46b347b93841c97c0a.svg";
export { ForwardRef as ReactComponent };